import React, { useEffect, useState, useRef } from 'react';
import { Box } from '@mui/material';

const YouTubeVideo = ({ videoUrl, autoplay }) => {
  const [showVideo, setShowVideo] = useState(null);
  const playerRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!videoUrl) return;

    const videoId = videoUrl.split('v=')[1]?.split('&')[0];
    if (!videoId) return;

    // Wait for the YouTube API to be ready
    if (typeof window.YT !== 'undefined' && containerRef.current) {
      
      try {
        // Create the YouTube player
        playerRef.current = new window.YT.Player(containerRef.current, {
          videoId: videoId,
          playerVars: {
            autoplay: autoplay ? 1 : 0, // Autoplay when ready
            mute: autoplay ? 1 : 0, // Mute initially if autoplay is true
            enablejsapi: 1, // Enable JS API control
            controls: 1, // Show video controls
          },
          events: {
            onReady: (event) => {
              setShowVideo(true);

              // iOS Safari requires user interaction to unmute
              if (autoplay) {
                event.target.playVideo(); // Start video immediately if autoplay is true
              }
            },
            onStateChange: (event) => {
              // 1 indicates the video is playing
              if (event.data === window.YT.PlayerState.PLAYING) {
                if (autoplay) {
                  // iOS requires this user interaction to unmute
                  setTimeout(() => {
                    event.target.unMute(); // Unmute the video after it starts playing
                  }, 500); // Short delay after video starts playing
                }
              }
            },
            // Gestione errori aggiuntiva per ID non esistenti
            onError: () => setShowVideo(false),
          },
        });
      } catch (error) {
        console.error("YouTube initialization error:", error.message);
        setShowVideo(false);
      }
    }

    // Cleanup: Destroy the player when the component unmounts
    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
      }
    };
  }, [autoplay, videoUrl]);

  return (
    <Box
      key={videoUrl} // Forces react to remount the component on URL change
      sx={{
        display: showVideo ? 'block' : 'none',
        position: 'relative',
        width: '100%',
        maxWidth: '800px',
        paddingTop: '56.25%', // 16:9 aspect ratio
        margin: '0 auto',
      }}
    >
      <div
        ref={containerRef}
        id="youtube-player-container"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </Box>
  );
};

export default YouTubeVideo;